import React from "react";
import "./About.css";

const About: React.FC = () => {
    return (
        <div className="about">
            <p className="about-description">
                I was a student at Rochester Institute of Technology with a BS in Computer Science. And I absolutely love to build, be it projects, contraptions, or even Legos. I am passionate about learning more and developing robust and impactful solutions to problems. 
                <br />
                <br />
                I've had opportunities to work on various projects from full stack development to machine learning, and I am always looking to learn more. 
            </p>
        </div>
    );
};  

export default About;
